import React from 'react';
import { NxInventoryStoreProvider } from '@warehouse/quickbase';
import { NxInventory } from '../../../../../libs/title/feature-nx-inventory';

function NxInventoryTab() {
	return (
		<NxInventoryStoreProvider>
			<NxInventory />
		</NxInventoryStoreProvider>
	);
}

export { NxInventoryTab };
